export default function (VirtualKeyboard) {
    return VirtualKeyboard.addLayout({
        code: 'AR-PRS',
        name: 'Dari',
        normal: "`١٢٣٤٥٦٧٨٩٠-=\\قوعرتىئءغپ[]اسدفگهجکل;'زخچژبنم,./",
        shift: { 0: '"!@#$%^&*()_+|ثأة', 18: 'طظلالا؟؛{}آصض', 31: 'ح', 35: ':"ذش', 44: '<>?' }
    })
}
